// import React, { useState, Fragment, Component } from 'react'
// import React, { Fragment, useState, Component, useRef, useEffect } from "react"

import React, { Fragment, useState, Component, useRef, useEffect} from "react"

import Shimmer from "react-shimmer-effect";
import moment from "moment"
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button
} from "reactstrap"
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";
import { AvField, AvForm} from "availity-reactstrap-validation"

import CustomSelect from "../../../../helpers/ui/CustomSelect";

import apiResponse from '../../../../services/apiResponse'

import DetailPegawaiBloc from './Blocs/DetailPegawaiBloc'
// import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar';
import Tabledetailpresensi from '../DetailPegawai/Components/TableDetailPegawaiComponent'
import TablePresensiDetail from '../DetailPegawai/Components/TablePresensiDetail'

const createYearOption = (startYear = 2000) => {
    var currentYear = new Date().getFullYear() + 10, years = [];
      startYear = startYear || 1980;  
      while ( startYear <= currentYear ) {
          var newObj = {};
          var year = startYear++;
          newObj["label"] = year;
          newObj["value"] = year;
          years.push(newObj);
      }   
      return years;
}
  
const createMonthOptions = () => {
      var months = [
          "Januari",
          "Februari",
          "Maret",
          "April",
          "Mei",
          "Juni",
          "Juli",
          "Agustus",
          "September",
          "Oktober",
          "November",
          "Desember",
      ];
  
      return months.map(function(month, i) {
          var newObj = {};
          newObj["label"] = month;
          newObj["value"] = ++i;
  
          return newObj;
      });
}

class IndexView extends Component {

    detailBloc = new DetailPegawaiBloc()

    userdata = JSON.parse(localStorage.getItem('userdata'));
    peg_uuid = this.userdata != null ? this.userdata.employee_uuid : "";
    peg_nip = this.userdata != null ? this.userdata.employee_nip : "";
    peg_name = this.userdata != null ? this.userdata.employee_name : "";
    peg_jabatan = this.userdata != null ? this.userdata.employee_current_position_name : "";
    peg_unit = this.userdata != null ? this.userdata.employee_current_work_unit_name : "";

    constructor(props) {
        super(props)
        this.state = {
            start_date : moment().startOf('month').format('YYYY-MM-DD'),
            end_date : moment().endOf('month').format('YYYY-MM-DD'),
            // start_date:'',
            // end_date:'',
            yearOptions: createYearOption(new Date().getFullYear() - 30),
            monthOptions: createMonthOptions(),
            year: new Date().getFullYear(),
            month: moment().format('M')
        }

        this.activeRef =  React.createRef()
    }
    

    componentDidMount() {
        // const activeRef = useRef();

        this.detailBloc.fetchDetail({uuid: this.peg_uuid})
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            detail: response
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
    }

    reset = () =>
    {
        this.setState({start_date:'', end_date:''})
    }

    reloadActiveRef = () => this.activeRef.current.setTokenAPI()

    handleButtonSearch = () => {
        this.reloadActiveRef();
    }

    render() {

        // const [nip, start_date] = useState('')
        // const [name, end_date] = useState('')

        // function handleButtonReset() {
        //     start_date('');
        //     end_date('');
        // }

        let filter = {
            // year: this.state.year,
            // month: this.state.month,
            start_date: this.state.start_date,
            end_date: this.state.end_date
        }

        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            {/* <PegawaiSideBar active="riwayatsumpah"/> */}

                            <Card>
                                <CardBody>
                                    <CardTitle>Detail Data Presensi</CardTitle>
                                    <CardSubtitle className="mb-1">
                                        Informasi Detail Data Presensi
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-1">
                                            <label className="col-md-3">
                                                NIP
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.peg_nip
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-1">
                                            <label className="col-md-3">
                                                Nama
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.peg_name
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-1">
                                            <label className="col-md-3">
                                                Jabatan
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.peg_jabatan
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-1">
                                            <label className="col-md-3">
                                                Unit Kerja
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.peg_unit
                                                }
                                            </Col>
                                        </Row>

                                        <hr />

                                        <Row className="mb-1">
                                            <label className="col-md-3">
                                                Periode Mulai
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="start_period"
                                                    placeholder="Periode Mulai..."
                                                    type="date"
                                                    errorMessage="Masukkan Periode Mulai"
                                                    className="form-control"
                                                    onChange={event => this.setState({start_date:event.target.value})}
                                                    id="start_period"
                                                    value={this.state.start_date}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Periode Akhir
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="end_period"
                                                    placeholder="Periode Akhir..."
                                                    type="date"
                                                    errorMessage="Masukkan Periode Akhir"
                                                    className="form-control"
                                                    onChange={event => this.setState({end_date:event.target.value})}
                                                    id="end_period"
                                                    value={this.state.end_date}
                                                    min={this.state.start_date}
                                                    validate={{
                                                        min: { value: this.state.start_date, errorMessage: 'Periode akhir tidak boleh kurang dari periode mulai' }
                                                    }}
                                                />
                                            </Col>
                                        </Row>

                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Bulan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                <CustomSelect 
                                                    name="period_month"
                                                    errorMessage="Pilih Bulan"
                                                    options={this.state.monthOptions} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Bulan"
                                                    defaultValue={this.state.month}
                                                    onChange={(v) => this.setState({month: v.value})}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tahun <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                <CustomSelect 
                                                    name="period_year"
                                                    errorMessage="Pilih Tahun"
                                                    options={this.state.yearOptions} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Tahun"
                                                    defaultValue={this.state.year}
                                                    onChange={(v) => this.setState({year: v.value})}
                                                />
                                            </Col>
                                        </Row> */}

                                        <Col md="12">
                                          <Button 
                                              color="primary" 
                                              type="button"
                                              onClick={() => {
                                                  this.handleButtonSearch()
                                              }}
                                          >
                                              <i className="uil-search-alt"></i> Cari
                                          </Button>
                                          {' '}
                                          {/* <Button 
                                            color="warning" 
                                            type="button"
                                            onClick={() => {
                                                  this.reset()
                                              }}
                                            >
                                              <i className="uil-refresh"></i> Reset
                                          </Button> */}
                                          {' '}
                                          
                                          {
                                            this.userdata?.is_atasan == 1 &&
                                            <Link to="?listatasan">
                                                <Button color="info">Kehadiran Anggota</Button>
                                            </Link>
                                          }
                                          <div className="p-2 bd-highlight float-end">
                                              <div style={{paddingTop: 8}}>
                                                  <i className="bx bx-mobile-alt"></i> Absensi Mobile
                                              </div>
                                          </div>

                                          <div className="p-2 bd-highlight float-end">
                                            <div style={{paddingTop: 8}}>
                                                <i className="bx bx-fingerprint"></i> Absensi Mesin
                                            </div>
                                          </div>
                                        </Col>
                                    <hr/>
                                          
                                    <Col md="12">
                                      {/* <Tabledetailpresensi ref={this.activeRef} uuid={this.peg_uuid} filter={filter}></Tabledetailpresensi> */}
                                      <TablePresensiDetail ref={this.activeRef} uuid={this.peg_uuid} filter={filter}></TablePresensiDetail>
                                    </Col>
                                                                            
                                        {/* <Row className="mb-1">
                                            <Col md="3"></Col>
                                                <Link to="/kepegawaian/presensi.html?" className="waves-effect">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                        </Row> */}
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);